import {
  incidentsPayloadTransformer,
  incidentsTransformer,
} from './IncidentsTransformer';

import type { Incident, IncidentsPayload } from '@cobliteam/common-types';

import type { Configuration, IRequest } from '../..';
import HttpMethod from '../../request/HttpMethod';
import Requester from '../../request/Requester';
import TimeZone from '../../request/Timezone';

class IncidentsRequester {
  private requester: Requester;

  constructor(configuration: Configuration) {
    this.requester = new Requester(configuration);
  }

  public getRequester = () => this.requester;

  public getIncidents = (data: IncidentsPayload): Promise<Incident[]> => {
    const incidentsData = incidentsPayloadTransformer(data);
    const tz = TimeZone.getEncodedTimeZone();

    const requestData: IRequest = {
      endpoint: `/stats/incidents?&end=${incidentsData.end_time}&tz=${tz}&amount=${incidentsData.amount}`,
      method: HttpMethod.GET,
    };

    return this.requester
      .request(requestData)
      .then((response) => incidentsTransformer(response.data));
  };
}

export default IncidentsRequester;
